"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const CarrySvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.66667 5.33317V3.99984C4.66667 3.11578 5.01786 2.26794 5.64298 1.64281C6.2681 1.01769 7.11595 0.666504 8 0.666504C8.88406 0.666504 9.7319 1.01769 10.357 1.64281C10.9821 2.26794 11.3333 3.11578 11.3333 3.99984V5.33317H13.3333C13.5101 5.33317 13.6797 5.40341 13.8047 5.52843C13.9298 5.65346 14 5.82303 14 5.99984V13.9998C14 14.1766 13.9298 14.3462 13.8047 14.4712C13.6797 14.5963 13.5101 14.6665 13.3333 14.6665H2.66667C2.48986 14.6665 2.32029 14.5963 2.19526 14.4712C2.07024 14.3462 2 14.1766 2 13.9998V5.99984C2 5.82303 2.07024 5.65346 2.19526 5.52843C2.32029 5.40341 2.48986 5.33317 2.66667 5.33317H4.66667ZM4.66667 6.6665H3.33333V13.3332H12.6667V6.6665H11.3333V7.99984H10V6.6665H6V7.99984H4.66667V6.6665ZM6 5.33317H10V3.99984C10 3.4694 9.78929 2.9607 9.41421 2.58562C9.03914 2.21055 8.53043 1.99984 8 1.99984C7.46957 1.99984 6.96086 2.21055 6.58579 2.58562C6.21071 2.9607 6 3.4694 6 3.99984V5.33317Z" fill="currentColor" />
  </svg>

)

const CarryIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CarrySvg} {...props} />
);

export default CarryIcon